
import { AppConfig } from "@/utils/AppConfig";

import { useTranslation } from "react-i18next";
import { formatMoney } from "@/utils/helpers";
import OptionsAndAddonAccordion from "./Cashier/OptionsAndAddonAccordion";
import { CartItem } from "@/types/ApiTypes";

function TableOrdersModalItem({ item, length, index }: { item: CartItem; length: number; index: number }) {

    const { t } = useTranslation();




    return (
        <div className={`flex flex-col items-center p-2 ${index !== length - 1 ? "border-b border-gray-300" : ""
            }`}>
            <div className="flex w-full items-center justify-between gap-y-3">
                {/* quantity, image, name  */}
                <div className="flex items-center gap-x-3">
                    <p className="flex items-center gap-1 whitespace-nowrap text-lg font-bold">
                        x {item.quantity}
                    </p>
                    <img src={item.image} alt="item" className="h-w-14 w-14 rounded-md" />
                    <p className="max-w-[50%]">{t(item.nameEN, item.nameAR)}</p>
                </div>

                {/* price, delete  */}
                <div className="flex items-center gap-x-3">
                    <p
                        dir="rtl"
                        className="flex items-center gap-1 whitespace-nowrap text-base font-bold"
                    >
                        <span>{formatMoney(item.totalPriceWithTaxes)}</span>
                        <span>{AppConfig.currency.icon()}</span>
                    </p>


                </div>
            </div>

            <OptionsAndAddonAccordion
                addonsNames={item.addons || []}
                optionsNames={item.options || []}
            />
        </div>
    );
}

export default TableOrdersModalItem;
